// Icon lookup config for shell/Icon.svelte. Kept out of the component so the
// component itself stays under the repo's file-size budget.

// Apps with a Win98 / Mac-Platinum retro PNG at /icons/retro/<name>.png.
export const retroIcons = new Set([
  'address-book',
  'aquapaint',
  'books',
  'calculator',
  'calendar',
  'cards',
  'chat',
  'computer',
  'console',
  'contact-card',
  'dashboard',
  'dictionary',
  'document',
  'dvd-player',
  'facetime',
  'finder',
  'folder',
  'folder-desktop',
  'folder-documents',
  'folder-downloads',
  'folder-library',
  'folder-movies',
  'folder-music',
  'folder-pictures',
  'folder-projects',
  'folder-public',
  'folder-sites',
  'font-book',
  'gallery',
  'game',
  'game-center',
  'gear',
  'hard-drive',
  'infra-ops',
  'journal',
  'mail',
  'music',
  'notes',
  'pages',
  'photo-booth',
  'photos',
  'preview',
  'quicktime',
  'safari',
  'screen-capture',
  'search-clock',
  'shared-mac',
  'software-update',
  'stickies',
  'terminal',
  'textedit',
  'trash',
  'trash-full',
  'visualizer',
  'web-inspector',
  'welcome',
]);

// A few icons get an idle personality (see .anim-* in app.css).
export const idleAnims = {
  trash: 'wiggle',
  chat: 'bob',
  cloud: 'float',
  music: 'pulse',
  welcome: 'glow',
  game: 'bob',
};

// Icons that fall back to a raster PNG at /icons/<name>.png.
export const rasterIcons = new Set([
  'address-book',
  'chat',
  'computer',
  'content-editor',
  'drive-hd',
  'drive-usb',
  'finder',
  'folder',
  'folder-desktop',
  'folder-documents',
  'folder-downloads',
  'folder-library',
  'folder-movies',
  'folder-music',
  'folder-pictures',
  'folder-projects',
  'folder-public',
  'folder-sites',
  'game',
  'gear',
  'pdf-document',
  'resume',
  'safari',
  'search-clock',
  'shared-mac',
  'sidebar-apps',
  'sidebar-downloads',
  'sidebar-home',
  'trash',
  'welcome',
]);
